import { del, get, post, put } from "../api_helper"
import * as url from "./url"

const getContainers = bookingNo => get(`${url.GET_CONTAINERS}/${bookingNo}`);

export {
  getContainers
}